import React from 'react';
import { Helmet } from 'react-helmet';

function DataSafety_Seo() {
    return (
        <div>
            <Helmet>
                <title>Data Safety | Ifepay</title>
                <meta name="description" content="Learn about our data safety policy, we have created for your information to know why Ifepay collects and stores the data. If you want to delete your data stored with us you can
    request us to delete your account." />
                <meta property="og:title" content="Data Safety | Ifepay" />
                <meta property="og:description" content="Learn about our data safety policy, we have created for your information to know why Ifepay collects and stores the data. If you want to delete your data stored with us you can
    request us to delete your account." />
                <meta property="og:image" content="https://ifepay.co.uk/assets/images/logo.png" /> {/* Replace with actual image URL */}
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://ifepay.co.uk/data-safety"/>
            </Helmet>
        </div>
    )
}

export default DataSafety_Seo
